import { render, staticRenderFns } from "./GoodsFlow.vue?vue&type=template&id=6770cf63&scoped=true"
import script from "./GoodsFlow.vue?vue&type=script&lang=js"
export * from "./GoodsFlow.vue?vue&type=script&lang=js"
import style0 from "./GoodsFlow.vue?vue&type=style&index=0&id=6770cf63&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6770cf63",
  null
  
)

export default component.exports